import { jsx } from "react/jsx-runtime";
import DescriptionIcon from "@mui/icons-material/Description";
import { validateTidalLicense } from "../../base/index.js";
function Description(props) {
  return /* @__PURE__ */ jsx(
    DescriptionIcon,
    {
      "data-testid": "Description",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Description",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
Description.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "Description"
};
validateTidalLicense();
export {
  Description
};
//# sourceMappingURL=Description.js.map
